import { Pipe, PipeTransform } from '@angular/core';
import { MerchantStatusEnum } from 'app/models';

@Pipe({
  name: 'getMerchantStatusBackgroundColor',
})
export class GetMerchantStatusBackgroundColorPipe implements PipeTransform {
  transform(merchantStatus: MerchantStatusEnum): string {
    const merchantStatuses = MerchantStatusEnum;
    let status = '';
    if (
      merchantStatus >= MerchantStatusEnum.Sent &&
      merchantStatus <= MerchantStatusEnum.ForApproval &&
      merchantStatus !== MerchantStatusEnum.Draft
    ) {
      status = 'status-Yellow';
    } else if (
      merchantStatus === MerchantStatusEnum.RejectedInitialOnboarding ||
      merchantStatus === MerchantStatusEnum.RejectedFinalReview
    ) {
      status = 'status-Red';
    } else if (
      merchantStatus >= MerchantStatusEnum.ForPartnerSignature &&
      merchantStatus <= MerchantStatusEnum.OnGoingFinalReview
    ) {
      status = 'status-Orange';
    } else if (
      merchantStatus === MerchantStatusEnum.OnboardingCompleted ||
      merchantStatus === MerchantStatusEnum.Draft
    ) {
      status = 'status-Grey';
    } else if (merchantStatus === MerchantStatusEnum.Activated) {
      status = 'status-Green';
    }

    return status;
  }
}
